<template>
    <div class="animated fadeIn">
        <DynamicForm
                v-model="dataId"
                ref="dynamicForm"
                getRoot="/season"
                saveRoot="/season"
                @onTrashClick="onTrashClick"
                :formStructure="dataFormStructures.league">
        </DynamicForm>
        <ModalTrash
                ref="trash"
                root="/season"
                @onTrashSuccess="onTrashSuccess"
                :caption="Core.Definition.getDefinition('Suppression de la saison')"
                :message="Core.Definition.getDefinition('Êtes-vous sûr de vouloir supprimer cette saison?')"></ModalTrash>
    </div>
</template>

<script>
    import DynamicForm from '../../components/DynamicForm'
    import ModalTrash from '../../components/ModalTrash'
    export default {
        name: 'Season',
        components: {
            DynamicForm,
            ModalTrash
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core,
                dataId: '',
                dataFormStructures: {
                    league: {
                        rows: [
                            {
                                cols: [
                                    {
                                        cards: [
                                            {
                                                caption: Core.Definition.getDefinition('Saison'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'title'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'description'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'title',
                                type: 'text',
                                label: Core.Definition.getDefinition('Titre'),
                                value: '',
                                sortable: true
                            },
                            {
                                id: 'description',
                                type: 'editor',
                                label: Core.Definition.getDefinition('Description'),
                                value: '',
                                sortable: true
                            }
                        ]
                    }
                }
            }
        },
        methods: {
            onTrashClick(id) {
                this.$refs.trash.open(id)
            },
            onTrashSuccess() {
                this.$router.push('/evenement/saisons')
            }
        }
    }
</script>
